fx.ns("desktop.common.panels", class ProposePreviewPanel extends fx.Component {
    
	constructor()
	{
		super();
		
        this.showEffect = "vslidein";

		this.destroyOnSwitch = true;
	}


	onReady()
	{
		super.onReady();
		this.listenUpdates(this.data.creation, true);
	}

	create()
	{
		super.create();
		
		let mainbox = new fx.components.Box("container");

        this.title = new fx.components.Text({text: fx.text("J'ai préparé l'aperçu de votre album"), className:"title medium bold center"});
        this.text = new fx.components.Text({text: fx.text("Cet aperçu vous montre comment sera votre album une fois imprimé.<br/>Assurez-vous de n'avoir rien oublié avant de commander."), className:"text center"});
        this.continueButton = new fx.components.Button({label :fx.text("Continuer"), type : "filled"});
        this.continueButton.attr("data-testid", "propose-preview-continue");
		mainbox.addChild(new shared.component.Person(fx.get("assets").splashPhoto), {width:200, height : 200, top : 0, left : "center"});
        mainbox.addChild(this.title, {top: 220, width: "100%"});
        mainbox.addChild(this.text, {top: 270, width: "100%"});
        mainbox.addChild(this.continueButton, {width : 200, top: 350, left : "center"});
        this.addChild(mainbox, { top: "center", left: "center", height: 450, width: 600 })

		this.on("click", this._onContinue, this.continueButton);	
	}

	_onContinue()
    {
        //this.data.event("preview");
        this.data.event("next-step");
        //this.data.event("preview");
    }

});
